import React from 'react';

import { Webform } from '@uncinc/react-drupal-core';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { Text } from '../../../components';

import { ParagraphWebform as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphWebformProps {
  entity: ImmutableEntity<Type>;
}

const ParagraphWebform: React.FC<ParagraphWebformProps> = ({ entity }) => {
  const paragraphWebform = entity.toJS();
  const title = paragraphWebform.field_title?.[0]?.value;
  const body = paragraphWebform.field_body?.[0]?.processed || '';

  const { status, target_id: id } = paragraphWebform.field_webform[0];

  return (
    <div className="Paragraph ParagraphWebform">
      <Container>
        <Text
          title={title}
          text={body}
        />
        <Webform id={id} status={status} />
      </Container>
    </div>
  );
};

export default ParagraphWebform;
